import { ChevronRight } from "lucide-react";
import type { Money } from "@empite/api-client";
import { formatMoney } from "@empite/api-client";
import { AppIcon } from "./app-icon";
import type { AppIdentity } from "./app-identity";
import { UiLink } from "./router";
import { StatusPill, outcomeTone } from "./status-pill";

/** The same wallet as {@link WalletCard}, compact, for a list rather than a grid. */
export function WalletRow({
  app,
  available,
  held,
  status,
}: {
  app: AppIdentity;
  available: Money;
  held: Money;
  status: string;
}) {
  return (
    <UiLink
      href={`/wallets/${app.id}`}
      className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-surface-sunken/60 sm:px-6"
    >
      <AppIcon initial={app.initial} tone={app.tone} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="truncate text-base font-semibold text-ink">{app.name}</p>
          <StatusPill tone={outcomeTone(status)} className="hidden sm:inline-flex">
            {status}
          </StatusPill>
        </div>
        {app.slug ? (
          <p className="truncate font-mono text-2xs text-ink-4">{app.slug}</p>
        ) : null}
      </div>
      <div className="text-right">
        <p className="tnum text-md font-bold text-ink">{formatMoney(available)}</p>
        <p className="tnum text-2xs text-ink-4">held {formatMoney(held)}</p>
      </div>
      <ChevronRight
        className="size-4 shrink-0 text-ink-4 transition-transform duration-150 group-hover:translate-x-0.5 group-hover:text-brand"
        aria-hidden
      />
    </UiLink>
  );
}
